/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 提交提现申请
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  extractApply: member.ExtractApplyDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/extract`,
    data: extractApply,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
